import Store from 'store/store';
import { openSidePanel, closeSidePanel } from 'store/bolt/sidePanelLoader';


Store.on('HOMEENT_SHOW', (animate, queryString, pageId) => openSidePanel(animate, 'homeEnt', false, queryString, pageId));

Store.on('HOMEENT_HIDE', (animate, updateActivePage = true) => closeSidePanel(animate, updateActivePage, 'homeEnt'));

Store.on('CLOSE_ALL_OVERLAYS', (options = {}) => {
	Store.emit('HOMEENT_HIDE', options.animate, false);
});
